import { KeyboardDetectionProvider, screenLgMax, screenMdMax, screenSmMax, spacer24, spacer32, spacer40, spacer48, spacer56, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { Grid, ONE_COLUMN_MAX_WIDTH, VideoCarousel, VideoCarouselProvider, } from '../../ui';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { SectionHeader, } from '../../ui/Components/SectionHeader';
const Wrapper = styled(Grid) `
  padding-top: ${spacer56};
  padding-bottom: ${spacer24};
  gap: ${spacer32};

  @media (max-width: ${screenLgMax}) {
    padding-top: ${spacer48};
  }

  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    padding-top: ${spacer40};
  }
`;
const CarouselWrapper = styled.div `
  grid-column: 1 / -1;
`;
const SectionHeaderWrapper = styled(SectionHeader) `
  grid-column: 1 / 7;
  @media (max-width: ${screenLgMax}) {
    grid-column: 1 / 8;
  }
  @media (max-width: ${screenMdMax}) {
    grid-column: 1 / 9;
  }
  @media (max-width: ${screenSmMax}) {
    grid-column: 1 / -1;
  }
`;
const getAllVideosFromSubCategories = (subCategories) => {
    const subCatVids = subCategories === null || subCategories === void 0 ? void 0 : subCategories.map(subCat => subCat.videos.map(vid => {
        return { ...vid, category: subCat.title };
    }));
    return subCatVids === null || subCatVids === void 0 ? void 0 : subCatVids.reduce((a, b) => {
        return a.concat(b);
    });
};
export const FullWidthCarouselModule = React.forwardRef(({ useSubCategories, subCategories, videos, colors, ...sectionHeadingProps }, ref) => {
    const { heading, body, eyebrow, subhead } = sectionHeadingProps;
    const useSectionHeader = heading || body || eyebrow || subhead;
    const allVideos = useSubCategories
        ? getAllVideosFromSubCategories(subCategories)
        : videos;
    if (!allVideos) {
        return null;
    }
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors },
            React.createElement(Wrapper, { bottomText: useSectionHeader ? true : false, ref: ref },
                useSectionHeader && (React.createElement(SectionHeaderWrapper, { ...sectionHeadingProps })),
                React.createElement(CarouselWrapper, { id: "carousel" },
                    React.createElement(VideoCarouselProvider, null,
                        React.createElement(VideoCarousel, { videos: allVideos, useControlNumbers: false, contentType: "fullWidthCarousel" })))))));
});
